@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=Inter+Tight:wght@400;500;600&display=swap');
@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  --font-heading: 'Libre Baskerville', serif;
  --font-body: 'Inter Tight', sans-serif;
  --font-label: 'Inter Tight', sans-serif;

  --background-50: 0.99 0.003 30; --background-100: 0.97 0.005 30; --background-200: 0.93 0.007 30;
  --background-300: 0.88 0.008 30; --background-400: 0.78 0.01 30; --background-500: 0.68 0.01 30;
  --background-600: 0.56 0.01 30; --background-700: 0.45 0.01 30; --background-800: 0.34 0.01 30;
  --background-900: 0.25 0.01 30; --background-950: 0.18 0.01 30;

  --primary-50: 0.97 0.02 25; --primary-100: 0.93 0.04 25; --primary-200: 0.86 0.08 25;
  --primary-300: 0.76 0.13 25; --primary-400: 0.64 0.19 25; --primary-500: 0.55 0.21 27;
  --primary-600: 0.49 0.19 27; --primary-700: 0.42 0.16 27; --primary-800: 0.35 0.13 27;
  --primary-900: 0.28 0.1 27; --primary-950: 0.2 0.07 27;

  --accent-50: 0.98 0.02 85; --accent-100: 0.95 0.05 85; --accent-200: 0.9 0.09 85;
  --accent-300: 0.85 0.12 82; --accent-400: 0.8 0.14 80; --accent-500: 0.74 0.15 75;
  --accent-600: 0.64 0.14 70; --accent-700: 0.53 0.12 65; --accent-800: 0.43 0.1 62;
  --accent-900: 0.34 0.08 60; --accent-950: 0.25 0.06 60;

  --secondary-50: 0.97 0.01 160; --secondary-100: 0.94 0.03 160; --secondary-200: 0.88 0.05 160;
  --secondary-300: 0.8 0.08 160; --secondary-400: 0.68 0.1 160; --secondary-500: 0.55 0.1 160;
  --secondary-600: 0.47 0.09 160; --secondary-700: 0.4 0.08 160; --secondary-800: 0.33 0.06 160;
  --secondary-900: 0.27 0.05 160; --secondary-950: 0.2 0.04 160;

  --foreground-50: 0.98 0 0; --foreground-100: 0.95 0 0; --foreground-200: 0.88 0 0;
  --foreground-300: 0.8 0 0; --foreground-400: 0.68 0 0; --foreground-500: 0.56 0 0;
  --foreground-600: 0.46 0 0; --foreground-700: 0.38 0 0; --foreground-800: 0.3 0 0;
  --foreground-900: 0.23 0 0; --foreground-950: 0.17 0 0;
}

html { scroll-behavior: smooth; }
body { font-family: var(--font-body); }

@keyframes fadeUp { from { opacity: 0; transform: translateY(24px); } to { opacity: 1; transform: none; } }
.fade-up { animation: fadeUp 0.8s ease both; }